export default "__VITE_ASSET__BJJXwwGp__"